import api, { errorMessage } from "./api";

const tokenAuth = {
  signup(username, email, password, cb, setError) {
    api
      .post("/api/signup/", { name: username, email, password })
      .then((response) => cb(response.data))
      .catch((error) => {
        setError(
          errorMessage(
            error,
            "Oops! Looks like there was an error creating your account.",
          ),
        );
      });
  },
  signin(email, password, cb, setError) {
    api
      .post("/api/signin/", { email, password })
      .then((response) => cb(response.data))
      .catch((error) => {
        // 401 here means "wrong password", not "session expired", so give the
        // real message rather than the generic one.
        if (error.response && error.response.status === 401) {
          setError("Your email or password was incorrect.");
          return;
        }
        setError(
          errorMessage(error, "We couldn't sign you in. Please try again."),
        );
      });
  },
  signout(authedUser, cb) {
    // Sign out locally whatever the server says — a failed request must never
    // leave someone stuck in a session they asked to end.
    api.post("/api/logout/").then(cb).catch(cb);
  },
};

export default tokenAuth;
